import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderService } from '../loader.service'

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css'],
  standalone: false
})
export class LoaderComponent implements OnInit {

  isLoading!: Subject<boolean>;

  constructor(private loaderService: LoaderService) { }

  ngOnInit() {
    this.isLoading = this.loaderService.isLoading;
  }

}
